export const TESTIMONIALS = {
  testimonials: [
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    'Nunc consequat interdum varius sit amet mattis vulputate enim. Eget magna fermentum iaculis eu non diam phasellus vestibulum.',
    'Nunc sed id semper risus in hendrerit. Pulvinar elementum integer enim neque volutpat ac tincidunt vitae semper.',
  ]
};